export const CONTACT_LOGS = `
query contactLogs(
  $tenant_id: Int!,
  $skip: Int,
  $take: Int,
  $orderBy: ContactLogOrderInput,
  $filter: FilterContactLogInput,
  $searchText: String
){
  contactLogs(
    tenant_id:$tenant_id,
    skip:$skip,
    take:$take,
    orderBy:$orderBy,
    filter:$filter,
    searchText:$searchText
  ){
    __typename
    ...on ContactLog{
      id
      contact_id
      contact{
        id
        firstname
        lastname
      }
      log_action_id
      log_action{
        id
        name
        translation_key
      }
      old_status_id
      old_status{
        id
        name
      }
      new_status_id
      new_status{
        id
        name
      }
      user{
        email
        contact {
          firstname
          lastname
        }
      }
      description
      role_type
      its
    }
    ...on ResultError{
      status_code
      message
      message_translation_key
    }
  }
}
`;

export const CONTACT_LOG_COUNT = `
query contactLogCount(
  $tenant_id: Int!,
  $filter: FilterContactLogInput,
  $searchText: String
){
  contactLogCount(
    tenant_id:$tenant_id,
    filter:$filter,
    searchText:$searchText
  ){
    __typename
    ...on Count{
      count
    }
    ...on ResultError{
      status_code
      message
      message_translation_key
    }
  }
}
`;
